"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Bracket["default"];
  }
});
var _Bracket = _interopRequireDefault(require("./Bracket"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }